/* CCC 2026-11-03 – Merkliste mit Wunschzettel (Kern). Module: ccc28-vergleich.js (Kategorien), ccc28-produkt.js
   (Produktseite: Merken, Versand, Tamper-Grösse). Texte: ccc28-text.js.
   Daten und Schalter: sections/ccc28-extras.liquid (Fusszeile, Theme-Editor «CCC Merkliste & Extras»).
   Merkliste und Wunschzettel liegen nur im Browser (localStorage «ccc28-merkliste», «ccc28-wunschzettel»).
   Rückgängig: Abschnitt in der Fusszeile ausblenden oder entfernen. */
(function () {
  if (window.ccc28Ready) return;
  var dataEl = document.getElementById('ccc28-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent) || {}; } catch (e) { return; }
  window.ccc28Ready = true;
  var S = D.s || {};
  var LANG = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var ROOT = String(D.root || '/').replace(/\/$/, '');

  var X = window.ccc28Text || { TX: { de: {} }, LBL: { de: {} }, VAL: {} };
  var TX = X.TX, LBL = X.LBL, VAL = X.VAL;
  var HOOKS = { card: [], after: [] };
  var LI = { de: 0, en: 1, fr: 2, it: 3, es: 4, pt: 5 }[LANG];
  if (LI == null) LI = 0;
  var T = TX[LANG] || TX.de, LB = LBL[LANG] || LBL.de;
  function t(k, v) {
    var s = T[k] != null ? T[k] : (TX.de[k] || '');
    if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
    return s;
  }
  function val(x) { var r = VAL[x]; return r ? r[LI] : x; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(x) { var s = String(Math.round(Number(x) * 100) / 100); return LANG === 'en' ? s : s.replace('.', ','); }
  function money(c) {
    if (c == null || isNaN(c)) return '';
    var f = D.mf || 'CHF {{amount}}', m = /\{\{\s*(\w+)\s*\}\}/.exec(f), k = m ? m[1] : 'amount';
    function fm(dec, th, ds) { var p = (Number(c) / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
    var v = k === 'amount_no_decimals' ? fm(0, ',', '.') : k === 'amount_with_comma_separator' ? fm(2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? fm(0, '.', ',') : k === 'amount_with_apostrophe_separator' ? fm(2, "'", '.') : k === 'amount_with_space_separator' ? fm(2, ' ', ',') : k === 'amount_with_period_and_space_separator' ? fm(2, ' ', '.') : fm(2, ',', '.');
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function img(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=' + (w || 200); }
  function pub(n, d) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {} }
  function lsGet(k, d) { try { var v = JSON.parse(localStorage.getItem(k) || 'null'); return v == null ? d : v; } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssGet(k, d) { try { var v = JSON.parse(sessionStorage.getItem(k) || 'null'); return v == null ? d : v; } catch (e) { return d; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/i;
  var HEART = '<svg class="ccc28-hs" viewBox="0 0 64 64" width="20" height="20" aria-hidden="true" focusable="false"><path d="M32 53.5C29.6 51.6 8.5 37.4 8.5 22.6 8.5 15.1 14.3 9.5 21.4 9.5c4.7 0 8.6 2.6 10.6 6.4 2-3.8 5.9-6.4 10.6-6.4 7.1 0 12.9 5.6 12.9 13.1C55.5 37.4 34.4 51.6 32 53.5Z"/></svg>';
  var XICON = '<svg viewBox="0 0 64 64" width="20" height="20" aria-hidden="true" focusable="false" fill="none"><path d="M52.5 11 11.9 51.6M52.5 51.6 11.9 11" stroke="currentColor" stroke-width="4"/></svg>';

  /* ---------- Produktdaten (Merkliste, Wunschzettel) ---------- */
  var PCACHE = ssGet('ccc28-p:' + LANG, {}) || {};
  function product(h) {
    var c = PCACHE[h];
    if (c && Date.now() - c.at < 10 * 60 * 1000) return Promise.resolve(c.p);
    return fetch(ROOT + '/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p) { PCACHE[h] = { at: Date.now(), p: { id: p.id, h: p.handle, t: p.title, u: p.url, i: p.featured_image, a: p.available, p: p.price, vs: (p.variants || []).map(function (v) { return { id: v.id, t: v.title, a: v.available, p: v.price }; }) } }; ssSet('ccc28-p:' + LANG, PCACHE); return PCACHE[h].p; }
        return null;
      })
      .catch(function () { return null; });
  }

  /* ---------- Merkliste ---------- */
  var KEY = 'ccc28-merkliste', WKEY = 'ccc28-wunschzettel';
  function list() { var a = lsGet(KEY, []); return Array.isArray(a) ? a.filter(function (x) { return x && HANDLE.test(x.h || ''); }) : []; }
  function setList(a) { lsSet(KEY, a.slice(0, 60)); sync(); }
  function has(h) { return list().some(function (x) { return x.h === h; }); }
  function save(it) { var a = list().filter(function (x) { return x.h !== it.h; }); it.at = Date.now(); a.unshift(it); setList(a); pub('ccc:merkliste_add', { handle: it.h }); }
  function drop(h) { setList(list().filter(function (x) { return x.h !== h; })); pub('ccc:merkliste_remove', { handle: h }); }

  function sync() {
    var n = list().length;
    document.querySelectorAll('.ccc28-hl').forEach(function (a) {
      var b = a.querySelector('.ccc28-hl__n'), bn = n ? String(n) : '';
      if (b && b.textContent !== bn) b.textContent = bn;
      a.classList.toggle('has-items', n > 0);
      a.setAttribute('aria-label', t('count_aria', { n: n }));
    });
    document.querySelectorAll('[data-ccc28-count]').forEach(function (e) { var c = n ? '(' + n + ')' : ''; if (e.textContent !== c) e.textContent = c; });
    document.querySelectorAll('[data-ccc28-h]').forEach(function (b) {
      var on = has(b.getAttribute('data-ccc28-h'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var nm = b.getAttribute('data-ccc28-t') || '';
      b.setAttribute('aria-label', t(on ? 'unsave_aria' : 'save_aria', { t: nm }));
      var l = b.querySelector('.ccc28-pbtn__l');
      if (l && l.textContent !== (on ? t('saved') : t('save'))) l.textContent = on ? t('saved') : t('save');
    });
    document.querySelectorAll('.ccc28-pbtn__see').forEach(function (a) { a.hidden = !has(a.getAttribute('data-h')); });
  }

  var toastT;
  function toast(msg, act) {
    var el = document.querySelector('.ccc28-toast');
    if (!el) { el = document.createElement('div'); el.className = 'ccc28-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
    el.innerHTML = esc(msg) + (act ? ' <button type="button" class="ccc28-toast__a">' + esc(t('toast_view')) + '</button>' : '');
    var b = el.querySelector('.ccc28-toast__a');
    if (b) b.addEventListener('click', function () { el.classList.remove('is-on'); openDrawer('own'); });
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 4200);
  }

  function toggleItem(it, btn) {
    if (has(it.h)) { drop(it.h); toast(t('toast_removed')); }
    else {
      var first = !lsGet('ccc28-seen', false);
      save(it);
      lsSet('ccc28-seen', true);
      toast(t('toast_saved'), true);
      if (btn && first) btn.classList.add('is-pop');
    }
  }

  /* Kopfzeile */
  function header() {
    if (!S.wl || !S.wlh) return;
    var icons = document.querySelector('.site-nav__icons');
    if (!icons || icons.querySelector('.ccc28-hl')) return;
    var a = document.createElement('a');
    a.href = '#merkliste';
    a.className = 'site-nav__link site-nav__link--icon ccc28-hl';
    a.innerHTML = HEART + '<span class="ccc28-hl__n" aria-hidden="true"></span>';
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer('own'); });
    var cart = icons.querySelector('is-land--toggle-cart');
    icons.insertBefore(a, cart || null);
  }

  /* Produktkarten */
  function cardInfo(c) {
    var h = c.getAttribute('data-product-handle');
    var tEl = c.querySelector('.grid-product__title');
    var im = c.querySelector('.grid-product__image-wrap img');
    var a = c.querySelector('a.grid-item__overlay-link, a[href*="/products/"]');
    return { h: h, t: tEl ? tEl.textContent.replace(/\s+/g, ' ').trim() : (a && a.getAttribute('aria-label')) || h, i: im ? (im.currentSrc || im.src || '') : '', u: a ? a.getAttribute('href') : ROOT + '/products/' + h };
  }
  function cards() {
    var added = 0;
    document.querySelectorAll('.grid-product [data-product-handle]').forEach(function (c) {
      if (c.getAttribute('data-ccc28')) return;
      var h = c.getAttribute('data-product-handle');
      if (!h || !HANDLE.test(h)) return;
      c.setAttribute('data-ccc28', '1');
      added++;
      var info = cardInfo(c);
      var wrap = c.querySelector('.grid-product__image-wrap');
      if (S.wl && S.wlc && wrap) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ccc28-heart';
        b.setAttribute('data-ccc28-h', h);
        b.setAttribute('data-ccc28-t', info.t);
        b.innerHTML = HEART;
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleItem(cardInfo(c), b); });
        wrap.appendChild(b);
      }
      HOOKS.card.forEach(function (f) { try { f(c, info, cardInfo); } catch (e) {} });
    });
    if (added) { sync(); HOOKS.after.forEach(function (f) { try { f(); } catch (e) {} }); }
  }

  /* ---------- Seitenleiste (Merkliste / Wunschzettel) ---------- */
  var OV, lastFocus;
  function overlay() {
    if (OV) return OV;
    OV = document.createElement('div');
    OV.className = 'ccc28-ov';
    OV.hidden = true;
    OV.innerHTML = '<div class="ccc28-ov__bg" data-x></div><aside class="ccc28-dr" role="dialog" aria-modal="true" aria-labelledby="ccc28-dr-h" tabindex="-1">' +
      '<div class="ccc28-dr__head"><h2 class="ccc28-dr__h" id="ccc28-dr-h"></h2><button type="button" class="ccc28-x" data-x aria-label="' + esc(t('close')) + '">' + XICON + '</button></div>' +
      '<div class="ccc28-dr__tabs" role="tablist" hidden></div><div class="ccc28-dr__body"></div></aside>';
    document.body.appendChild(OV);
    OV.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) closeDrawer(); });
    OV.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(OV.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex="0"]')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    return OV;
  }
  function lock(on) { document.documentElement.classList.toggle('ccc28-lock', on); }
  function closeDrawer() {
    if (!OV || OV.hidden) return;
    OV.classList.remove('is-on');
    lock(false);
    setTimeout(function () { OV.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function shared() { var w = lsGet(WKEY, null); return w && Array.isArray(w.items) && w.items.length ? w : null; }
  function openDrawer(mode) {
    var ov = overlay();
    lastFocus = document.activeElement;
    var w = shared();
    if (mode === 'shared' && !w) mode = 'own';
    var tabs = ov.querySelector('.ccc28-dr__tabs');
    if (w) {
      tabs.hidden = false;
      tabs.innerHTML = '<button type="button" role="tab" data-m="own" aria-selected="' + (mode === 'own') + '">' + esc(t('wz_mine')) + '</button><button type="button" role="tab" data-m="shared" aria-selected="' + (mode === 'shared') + '">' + esc(w.n ? t('wz_title_n', { n: w.n }) : t('wz')) + '</button>';
      tabs.querySelectorAll('[data-m]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(b.getAttribute('data-m')); }); });
    } else { tabs.hidden = true; tabs.innerHTML = ''; }
    ov.hidden = false;
    lock(true);
    requestAnimationFrame(function () { ov.classList.add('is-on'); });
    render(mode, w);
    setTimeout(function () { var d = ov.querySelector('.ccc28-dr'); try { d.focus({ preventScroll: true }); } catch (e) {} }, 30);
    pub('ccc:merkliste_open', { mode: mode });
  }

  function itemRow(it, p, mode) {
    var v = null;
    if (p) {
      if (it.v) v = (p.vs || []).filter(function (x) { return String(x.id) === String(it.v); })[0] || null;
      if (!v && p.vs && p.vs.length === 1) v = p.vs[0];
    }
    var title = p ? p.t : it.t;
    var vt = v && p && p.vs.length > 1 && v.t !== 'Default Title' ? v.t : '';
    var price = v ? v.p : (p ? p.p : null);
    var avail = v ? v.a : (p ? p.a : true);
    var url = (p ? p.u : it.u) || (ROOT + '/products/' + it.h);
    if (v && p && p.vs.length > 1) url += (url.indexOf('?') > 0 ? '&' : '?') + 'variant=' + v.id;
    var im = p && p.i ? img(p.i, 200) : (it.i || '');
    var act;
    if (!avail) act = '<span class="ccc28-it__sold">' + esc(t('sold')) + '</span>';
    else if (v) act = '<button type="button" class="ccc28-btn ccc28-btn--dark" data-add="' + v.id + '">' + esc(t('add')) + '</button>';
    else act = '<a class="ccc28-btn" href="' + esc(url) + '">' + esc(t('choose')) + '</a>';
    return '<li class="ccc28-it' + (avail ? '' : ' is-sold') + '" data-h="' + esc(it.h) + '">' +
      '<a class="ccc28-it__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a>' +
      '<div class="ccc28-it__m"><a class="ccc28-it__t" href="' + esc(url) + '">' + esc(title) + '</a>' +
      (vt ? '<span class="ccc28-it__v">' + esc(vt) + '</span>' : '') +
      (price != null ? '<span class="ccc28-it__p">' + esc(money(price)) + '</span>' : '') +
      '<div class="ccc28-it__a">' + act + (mode === 'own' ? '<button type="button" class="ccc28-lnk" data-del="' + esc(it.h) + '">' + esc(t('remove')) + '</button>' : '') + '</div></div></li>';
  }

  function render(mode, w) {
    var ov = overlay(), body = ov.querySelector('.ccc28-dr__body'), h = ov.querySelector('.ccc28-dr__h');
    var items = mode === 'shared' ? w.items : list();
    h.textContent = mode === 'shared' ? (w.n ? t('wz_title_n', { n: w.n }) : t('wz_title')) : t('wl_title');
    var top = mode === 'shared' ? '<p class="ccc28-dr__lead">' + esc(w.n ? t('wz_t_n', { n: w.n }) : t('wz_t')) + '</p>' : '';
    if (!items.length) {
      body.innerHTML = top + '<p class="ccc28-dr__empty">' + esc(t('empty')) + '</p>';
      return;
    }
    body.innerHTML = top + '<ul class="ccc28-list" role="list">' + items.map(function (it) { return itemRow(it, null, mode); }).join('') + '</ul>' + (mode === 'own' ? shareBox() : giftLine());
    /* frische Preise und Verfügbarkeit nachladen */
    var ul = body.querySelector('.ccc28-list');
    var gone = 0;
    items.forEach(function (it) {
      product(it.h).then(function (p) {
        var li = ul.querySelector('[data-h="' + it.h + '"]');
        if (!li) return;
        if (!p) { li.remove(); gone++; if (!ul.children.length) ul.outerHTML = '<p class="ccc28-dr__empty">' + esc(t('wz_none')) + '</p>'; return; }
        var tmp = document.createElement('ul'); tmp.innerHTML = itemRow(it, p, mode);
        li.replaceWith(tmp.firstChild);
      });
    });
    body.onclick = function (e) {
      var d = e.target.closest('[data-del]');
      if (d) { drop(d.getAttribute('data-del')); render('own', shared()); return; }
      var a = e.target.closest('[data-add]');
      if (a) { addToCart(a.getAttribute('data-add'), a, mode); return; }
      var s = e.target.closest('[data-share]');
      if (s) { share(s.getAttribute('data-share')); }
    };
  }

  function addToCart(vid, btn, mode) {
    btn.disabled = true;
    var old = btn.textContent;
    btn.textContent = t('loading');
    fetch(ROOT + '/cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: 'cart-ajax', sections_url: location.pathname })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (res) {
      pub('ccc:merkliste_cart', { variant: vid, mode: mode });
      closeDrawer();
      try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res }, bubbles: true })); } catch (e) {}
      setTimeout(function () {
        var trg = document.getElementById('HeaderCartTrigger');
        if (trg && trg.getAttribute('aria-expanded') !== 'true') trg.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }, 150);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = old;
      toast(t('cart_err'));
    });
  }

  function shareBox() {
    return '<div class="ccc28-share"><h3 class="ccc28-share__h">' + esc(t('share_h')) + '</h3><p class="ccc28-share__t">' + esc(t('share_t')) + '</p>' +
      '<label class="ccc28-share__l" for="ccc28-name">' + esc(t('name_l')) + '</label><input class="ccc28-share__i" id="ccc28-name" type="text" maxlength="30" autocomplete="given-name" value="' + esc(lsGet('ccc28-name', '')) + '">' +
      '<div class="ccc28-share__b"><button type="button" class="ccc28-btn ccc28-btn--dark" data-share="go">' + esc(navigator.share ? t('share_btn') : t('copy_btn')) + '</button>' +
      (navigator.share ? '<button type="button" class="ccc28-lnk" data-share="copy">' + esc(t('copy_btn')) + '</button>' : '') +
      '<button type="button" class="ccc28-lnk" data-share="mail">' + esc(t('mail')) + '</button></div><p class="ccc28-share__ok" role="status" aria-live="polite"></p></div>';
  }
  function giftLine() {
    return '<p class="ccc28-dr__gift"><a href="' + esc(ROOT + String(D.gift || '/collections/geschenkgutscheine').replace(/^https?:\/\/[^/]+/, '')) + '">' + esc(t('wz_gift')) + '</a></p>';
  }
  function shareUrl() {
    var nm = (document.getElementById('ccc28-name') || {}).value || '';
    nm = nm.replace(/[<>"]/g, '').trim().slice(0, 30);
    lsSet('ccc28-name', nm);
    var items = list().slice(0, 30).map(function (x) { return x.h + (x.v ? '~' + x.v : ''); }).join(',');
    var u = location.origin + ROOT + '/?wunschzettel=' + encodeURIComponent(items).replace(/%2C/g, ',').replace(/%7E/gi, '~');
    if (nm) u += '&von=' + encodeURIComponent(nm);
    return u + '&utm_source=wunschzettel&utm_medium=share';
  }
  function share(kind) {
    var u = shareUrl(), ok = OV && OV.querySelector('.ccc28-share__ok');
    pub('ccc:wunschzettel_share', { kind: kind, n: list().length });
    if (kind === 'mail') { location.href = 'mailto:?subject=' + encodeURIComponent(t('mail_subj')) + '&body=' + encodeURIComponent(t('mail_body') + '\n' + u); return; }
    if (kind === 'go' && navigator.share) { navigator.share({ title: t('share_text'), text: t('share_text'), url: u }).catch(function () {}); return; }
    var done = function () { if (ok) ok.textContent = t('copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done, function () { fallbackCopy(u); done(); });
    else { fallbackCopy(u); done(); }
  }
  function fallbackCopy(u) {
    var ta = document.createElement('textarea'); ta.value = u; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} ta.remove();
  }

  /* geteilter Wunschzettel über den Link */
  function incoming() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var raw = q.get('wunschzettel');
    if (!raw) return;
    var items = raw.split(',').map(function (s) {
      var p = s.split('~'), h = (p[0] || '').trim(), v = (p[1] || '').replace(/\D/g, '');
      return HANDLE.test(h) ? { h: h, v: v || null } : null;
    }).filter(Boolean).slice(0, 30);
    if (!items.length) return;
    var n = (q.get('von') || '').replace(/[<>"]/g, '').trim().slice(0, 30);
    lsSet(WKEY, { items: items, n: n, at: Date.now() });
    pub('ccc:wunschzettel_open', { n: items.length });
    openDrawer('shared');
  }

  /* ---------- Start ---------- */
  var C = window.ccc28 = {
    D: D, S: S, LANG: LANG, ROOT: ROOT, LB: LB, t: t, val: val, esc: esc, num: num, money: money, img: img, pub: pub,
    lsGet: lsGet, lsSet: lsSet, ssGet: ssGet, ssSet: ssSet, HANDLE: HANDLE, HEART: HEART, XICON: XICON, KEY: KEY,
    list: list, has: has, toggleItem: toggleItem, openDrawer: openDrawer, closeDrawer: closeDrawer, toast: toast,
    addToCart: addToCart, lock: lock, sync: sync, hooks: HOOKS, started: false
  };
  var started = false;
  function start() {
    if (started) return;
    started = true;
    (window.ccc28Mods || []).forEach(function (m) { try { m(C); } catch (e) {} });
    C.started = true;
    header();
    cards();
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-ccc28-open]');
      if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-ccc28-open') === 'shared' ? 'shared' : 'own'); }
    });
    if (!S.wl) document.documentElement.classList.add('ccc28-no-wl');
    sync();
    incoming();
    var pend = null;
    if (window.MutationObserver) new MutationObserver(function () {
      if (pend) return;
      pend = setTimeout(function () { pend = null; header(); cards(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
    document.addEventListener('shopify:section:load', function () { header(); cards(); sync(); });
  }
  /* Module (defer, nach diesem Skript) melden sich vor DOMContentLoaded an */
  if (document.readyState === 'complete') start();
  else { document.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();
